
import axios from "axios";
import React, { useState } from "react";
import {useNavigate } from "react-router-dom";
import Loaders from "../components/Spinners/Loaders";


const AuthLogin = (props) =>{
    const Navigate = useNavigate();
    const [userDetails, setUserDetails] = useState("")
    
    try {
      axios.get('/user/loginauth')    
    .then(res => {
      if(res.data.Status === "Success")
    {    
    setUserDetails("OzoneDataSuccess");    
    }
    else
    {     
      Navigate('/');
    }
  }).then(err => console.log(err));
      
    } catch (error) {
      console.log(error);
      
    }
    

if(userDetails !== "OzoneDataSuccess"){
    return <Loaders />
}
return <div>
    {props.children}
</div>


}
export default AuthLogin;